import { useContext } from 'react';

import { ConnectorsContext, ConnectorsContextType } from '../context';

export const useConnectors = (): ConnectorsContextType =>
  useContext(ConnectorsContext);
